export class Responsavel {

  codigoUsuario: string;
  email: string;
  login: string;
  nome: string;
  status: boolean;

  montaResponsavel(nome: string, login: string) {
    this.login = login;
    this.nome = nome;
  }

}
